export const ActionTypes = {
  SET_ROCKETS: 'SET_ROCKETS',
  SELECTED_ROCKET: 'SELECTED_ROCKET',
  REMOVE_SELECTED_ROCKET: 'REMOVE_SELECTED_ROCKET',
};


export enum typeenum {
  SET_ROCKETS= 'SET_ROCKETS',
  SELECTED_ROCKET= 'SELECTED_ROCKET',
  REMOVE_SELECTED_ROCKET= 'REMOVE_SELECTED_ROCKET',
};